<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/dashboard">Admin</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page">Agencies</span>
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Agencies</h1>
        <p class="page-head__subtitle">
          Broker agencies whose members share a client portfolio. Create an agency and its founding
          admin — they invite the rest of their team themselves.
        </p>
      </div>
      <div class="page-head__actions">
        <button mat-flat-button color="primary" type="button" (click)="toggleAdd()">
          <app-icon [name]="addOpen() ? 'x' : 'plus'" [size]="18" />
          {{ addOpen() ? 'Cancel' : 'New agency' }}
        </button>
      </div>
    </div>
  </header>

  @if (addOpen()) {
    <section class="agencies-add" aria-label="New agency">
      <form [formGroup]="createForm" (ngSubmit)="submitCreate()" class="agencies-add__form">
        <div class="agencies-add__grid">
          <mat-form-field appearance="outline">
            <mat-label>Agency name</mat-label>
            <input matInput formControlName="name" autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Registration number (optional)</mat-label>
            <input matInput formControlName="reg_no" autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Admin first name</mat-label>
            <input matInput formControlName="admin_first_name" autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Admin last name</mat-label>
            <input matInput formControlName="admin_last_name" autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="agencies-add__email">
            <mat-label>Admin email</mat-label>
            <input matInput type="email" formControlName="admin_email" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="agencies-add__actions">
          <button mat-flat-button color="primary" type="submit" [disabled]="submitting()">
            {{ submitting() ? 'Creating…' : 'Create agency' }}
          </button>
        </div>
      </form>
    </section>
  }

  @if (isLoading()) {
    <div class="dash-skeleton" style="min-height: 240px"></div>
  } @else if (loadError()) {
    <div class="dash-panel">
      <div class="dash-empty">
        <span class="dash-empty__icon"><app-icon name="alert-triangle" [size]="32" /></span>
        <p class="dash-empty__title">Couldn't load agencies</p>
        <p class="dash-empty__body">Something went wrong on our side.</p>
      </div>
    </div>
  } @else if (agencies().length === 0) {
    <div class="dash-panel">
      <div class="dash-empty">
        <span class="dash-empty__icon"><app-icon name="briefcase" [size]="40" /></span>
        <p class="dash-empty__title">No agencies yet</p>
        <p class="dash-empty__body">Create the first agency to give a broker team a shared portfolio.</p>
      </div>
    </div>
  } @else {
    <div class="agencies-table-wrap">
      <table class="agencies-table">
        <thead>
          <tr>
            <th>Agency</th>
            <th>Reg. no</th>
            <th class="agencies-table__num">Members</th>
            <th class="agencies-table__num">Clients</th>
            <th>Created</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          @for (agency of agencies(); track agency.short_id) {
            <tr [class.agencies-table__row--inactive]="!agency.is_active">
              <td class="agencies-table__name">{{ agency.name }}</td>
              <td>{{ agency.reg_no | dash }}</td>
              <td class="agencies-table__num">{{ agency.member_count }}</td>
              <td class="agencies-table__num">{{ agency.client_count }}</td>
              <td>{{ agency.created_at | date: 'mediumDate' }}</td>
              <td>
                <mat-slide-toggle
                  [checked]="agency.is_active"
                  (change)="toggleActive(agency)"
                  [attr.aria-label]="'Toggle ' + agency.name + ' active'"
                />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
